const queryKeys = {
  all: (partyId: string) => ['claims', partyId],

  lists: (partyId: string) => [...queryKeys.all(partyId), 'list'],
  details: (partyId: string) => [...queryKeys.all(partyId), 'detail'],

  list: (partyId: string, filter: unknown) => [
    ...queryKeys.lists(partyId),
    filter,
  ],

  byId: (partyId: string, claimId: string) => [
    ...queryKeys.details(partyId),
    claimId,
  ],
};

export default queryKeys;
